import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHealthComponent } from "./med-icon-health.component";

@NgModule({
  declarations: [
    MedIconHealthComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHealthComponent,
  ],
})
export class MedIconHealthModule { }
